import Image from "@/components/AppImage";
import { getDashboardPathUrl } from "@/config/dashboardOrigin";
import Link from "@/components/AppLink";
import index3_illu from "/public/img/index3-illu.png";

const Banner = () => {
  return (
    <section className="banner-section index-3">
      <div className="overlay">
        <div className="banner-content pb-120">
          <div className="container">
            <div className="row">
              <div className="col-lg-7 col-md-10">
                <div className="main-content">
                  <h1>Launch your freelancer wallet in minutes</h1>
                  <p>
                    Verify once, connect your payout destination, and start
                    invoicing clients through 100+ payment methods—no lengthy
                    paperwork.
                  </p>
                  <Link href={getDashboardPathUrl("/register-2")} className="cmn-btn">
                    Request a Payment Now
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="banner-bottom">
              <p className="xxlr">
                Trusted by marketplaces and direct clients who need a fast,
                compliant way to pay independent talent.
              </p>
              <div className="row single-head justify-content-center align-items-center">
                <div className="col-xl-3 col-lg-6">
                  <Link href="#" className="single">
                    <Image
                      width={140}
                      height={38}
                      src="/img/marketplaces-1.png"
                      alt="image"
                    />
                  </Link>
                </div>
                <div className="col-xl-3 col-lg-6">
                  <Link href="#" className="single">
                    <Image
                      width={140}
                      height={38}
                      src="/img/marketplaces-2.png"
                      alt="image"
                    />
                  </Link>
                </div>
                <div className="col-xl-3 col-lg-6">
                  <Link href="#" className="single">
                    <Image
                      width={140}
                      height={38}
                      src="/img/marketplaces-3.png"
                      alt="image"
                    />
                  </Link>
                </div>
                <div className="col-xl-3 col-lg-6">
                  <Link href="#" className="single">
                    <Image
                      width={140}
                      height={38}
                      src="/img/marketplaces-4.png"
                      alt="image"
                    />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="right-illu">
        <Image className="right-1 wow fadeInUp" src={index3_illu} alt="image" />
      </div>
    </section>
  );
};

export default Banner;
